import React from "react";

import inputs from "../../../../../../components/inputs/inputConfigs/specCategory";
import { Input } from "../../../../../forms/FormGrid";

export const buildTemplateCategoryInput = scopeId => {
  if (!scopeId) return inputs.templateCategoryId;
  return {
    ...inputs.templateCategoryId,
    APIOptions: {
      ...inputs.templateCategoryId.APIOptions,
      rootFilters: { $where: { "scope.id": scopeId } },
    },
  };
};

export const buildScopeIdInput = setFieldValue => ({
  ...inputs.scopeId,
  handleChange: () => setFieldValue && setFieldValue("templateCategoryId", ""),
});

const templateFields = ({
  isSuperAdmin = false,
  isEditing = false,
  scopeId,
  setFieldValue,
} = {}) => ({
  groups: [
    {
      items: [
        {
          input: inputs.specCategoryName,
          grid: { xs: 6 },
        },
        {
          input: inputs.specCategoryType,
          grid: { xs: 6 },
        },
        {
          input: inputs.specCategoryKey,
          grid: { xs: 6 },
        },
        {
          input: inputs.isActive,
          grid: { xs: 6 },
        },
        {
          element: (
            <Input
              key={`templateCategoryId-${scopeId || "none"}`}
              input={buildTemplateCategoryInput(scopeId)}
            />
          ),
          grid: { xs: 6 },
        },
        ...(isSuperAdmin && !isEditing
          ? [
              {
                input: buildScopeIdInput(setFieldValue),
                grid: { xs: 6 },
              },
            ]
          : []),
      ],
    },
  ],
});

export default templateFields;
